import { type TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={[
          'w-full rounded-button border border-border bg-background px-3 py-2 text-sm text-foreground',
          'placeholder:text-placeholder',
          'transition-colors duration-80 ease-out',
          'focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'resize-y min-h-[80px]',
          className,
        ].join(' ')}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
